/**
 * Copyright Mántum All Rights Reserved.
 */
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import type { Group } from '../type';

type PropTypes = {
    onClick?: (value: Group) => void;
    selected?: Group;
    value: Group;
};

export default function Row(props: PropTypes) {
    // prettier-ignore
    const {
        value = {} as Group
    } = props

    // prettier-ignore
    const {
        key,
        name,
        icon = true 
    } = value

    const onClick = () => {
        if (props.onClick) {
            props.onClick(props.value);
        }
    };

    const selected = props.selected?.key === key ? 'text-primary' : '';

    return (
        <button
            className={`${selected} w-full py-2 hover:text-primary`}
            onClick={onClick}
            title={name}
            type='button'
        >
            <div className='mx-4 flex flex-row items-center justify-between text-base'>
                <span className='line-clamp-1 w-4/5 text-ellipsis break-all text-left'>
                    {name}
                </span>
                {icon && <ChevronRightIcon className='h-4 w-4' />}
            </div>
        </button>
    );
}
